export * from '../../common/store/mutations';

// Payments
export const SET_DISPLAY_MODE = 'setDisplayMode';
export const SET_CURRENT_CHOICE_SF_ID = 'setCurrentChoiceSfId';
export const SET_CURRENT_CHOICE_UID = 'setCurrentChoiceUid';
export const SET_CURRENT_CHOICE_IS_ALLOWED = 'setCurrentChoiceIsAllowed';
export const SET_PREVIOUS_CHOICE = 'setPreviousChoice';



// WEBPACK FOOTER //
// ./src/app/store/mutations.js